import { ReactElement, useEffect, useState } from 'react';
import SidePanelContainer from '../controls/SidePanelContainer';
import { Group, ParametersType, TimeSpan } from '../constants/telosair-interfaces';
import FloorView from '../components/FloorView';
import { useData } from '../context/data.context';
import DevicesChart from '../components/DeviceTimeseries';

type AddUserModalProps = {
  data: { serialNumber: number; parameter: ParametersType } | null;
  isModalOpen: boolean;
  handleClose: () => void;
  timeSpanDate: {
    startDate: number;
    endDate: number;
  };
  timeSpan: TimeSpan;
  /** Chart bucket width, inherited from the dashboard filter bar. */
  resolution?: string;
};

/**
 * Modal - DashboardSideBar.
 * @param props - Properties of DashboardSideBar.
 * @returns ReactElement.
 */
export default function DashboardSideBar(props: AddUserModalProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { isModalOpen, data, handleClose, timeSpanDate, timeSpan, resolution } = props;
  const { groupedData } = useData();
  const [selectedGroup, setSelectedGroup] = useState<Group[]>([]);

  useEffect(() => {
    const filteredGroup: Group[] = [];
    groupedData.forEach((item) => {
      item.sensorDetailsList.forEach((sensor) => {
        if (sensor.serial_number === data?.serialNumber) {
          filteredGroup.push(item);
        }
      });
    });
    setSelectedGroup(filteredGroup);
  }, [groupedData, data]);
  return (
    <SidePanelContainer width="w-9/12" isOpen={isModalOpen} closeModal={() => handleClose()}>
      <div className="pt-3 flex text-gray-500 dark:text-gray-300 text-lg">Snapshot View</div>
      <div className="pb-3 flex text-gray-500 dark:text-gray-500 text-sm">
        Setup custom thresholds for your Devices.
      </div>
      <div className="h-[44%] flex flex-1 flex-col">
        <FloorView
          selectedParameters={[]}
          selectedGroup={null}
          onGroupSelection={() => null}
          groups={selectedGroup}
          onDashBoard
          shouldHighlight
        />
      </div>
      <div className="w-full h-[31%] mt-6">
        <DevicesChart
          data={data}
          selectedGroup={selectedGroup[0]}
          timeSpan={timeSpan}
          timeSpanDate={timeSpanDate}
          resolution={resolution}
        />
      </div>
    </SidePanelContainer>
  );
}
